import axiosInstance from '@/utils/axiosInstance';

export type ClientLoans = {
  clientLoanCount: number;
  clientVoidedLoanCount: number;
};

export default async function getClientLoans() {
  return (await axiosInstance.get<ClientLoans>('/client/loans')).data;
}
